<template>
  <div class="page_all">
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">企業管理</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button class="btn_plus" @click="openModal()">＋</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_municipality">企業名</th>
            <th>組織ID</th>
            <th class="th_charge">担当</th>
            <th class="th_delete"></th>
            <th class="th_delete"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="muni in municipalities" v-bind:key="muni.municipality_key">
            <td class="td_municipality">
              {{ muni.municipality_name }}
            </td>
            <td>
              {{ muni.company_id }}
            </td>
            <td class="td_charge">
              <button class="btn_charge" v-on:click="municipalityCharge(muni.municipality_key)">担当</button>
            </td>

            <td class="btn_delete">
              <button class="btn_delete" v-on:click="openResetPasswordConfirm(muni.municipality_name, muni.company_id)">🔒</button>
            </td>
            
            <td class="btn_delete">
              <button class="btn_delete" v-on:click="companyDel(muni.municipality_key)">X</button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 以下モーダルウィンドウ 企業追加-->
      <modal v-if="showModal" @close="closeModal">
        <div class="modal_main">
          <table class="tbl_modal_search">
            <thead>
              <tr>
                <th class="th_modal_title">
                  <div>
                    <span>企業の追加</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr_modal">
                <div class="modal_search_title">
                  <label>企業名</label>
                </div>
                <div class="modal_search">
                  <input type="text" class="modal_input_keyword" v-model.trim="$v.companyName.$model"/>
                </div>
              </tr>
              <tr class="tr_modal">
                <td class="td_modal_message">
                  <div class="message">
                    <div v-if="$v.companyName.$dirty">
                      <div class="error" v-if="!$v.companyName.required">企業名は必須入力です。</div>
                      <div class="error" v-if="!$v.companyName.maxLength">企業名は{{ $v.companyName.$params.maxLength.max }}文字以内で入力してください。</div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="tr_modal">
                <div class="modal_search_title">
                  <label>組織ID</label>
                </div>
                <div class="modal_search">
                  <input type="text" class="modal_input_keyword" v-model.trim="$v.companyId.$model"/>
                </div>
              </tr>
              <tr class="tr_modal">
                <td class="td_modal_message">
                  <div class="message">
                    <div v-if="$v.companyId.$dirty">
                      <div class="error" v-if="!$v.companyId.required">組織IDは必須入力です。</div>
                      <div class="error" v-if="!$v.companyId.maxLength">組織IDは{{ $v.companyId.$params.maxLength.max }}文字以内で入力してください。</div>
                      <div class="error" v-if="!$v.companyId.customId">組織IDは半角英数字で入力してください。</div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_close">
                  <div class="div_btn">
                    <button :disabled="$v.$invalid" class="btn_general" @click="addCompany">追加</button>
                  </div>
                  <div class="div_btn">
                    <button class="btn_general" @click="closeModal">閉じる</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ -->
      <!-- 以下モーダルウィンドウ 仮パスワード-->
      <modal v-if="showPassModal" @close="closePassModal">
      <!-- <modal  @close="closePassModal"> -->
        <div class="modal_main">
          <table class="tbl_modal_temppass">
            <tbody>
              <tr class="tr_modal">
                <div class="modal_comment">企業名：{{ companyName }}会社を追加しました。</div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_temp_password">
                  <div>
                    仮パスワード： <label id="target_clipcopy">{{ temporaryPassword }}</label>
                  </div>
                  <div>
                    <button class="clipcopy" data-clipboard-target="#target_clipcopy" @click="clipboardCopy">クリップボードにコピー</button>
                  </div>
                </div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_close">
                  <div></div>
                  <div>
                    <button class="btn_general" @click="closePassModal">閉じる</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ -->
      <!-- 以下モーダルウィンドウ - パスワードリセット確認 -->
      <modal v-if="showModalResetPass" @close="closeModalConfirm">
        <div class="modal_main">
          <table class="tbl_modal">
            <tbody>
              <tr class="tr_modal">
                <div class="modal_confirm">
                  <span>名前：{{ resetCompanyName }} のパスワードをリセットしてよろしいですか？</span><br/>
                  <span>今までのパスワードが使用できなくなり、新しい仮パスワードが発行されます。</span>
                </div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_reset">
                  <div></div>
                  <div>
                    <button class="btn_modal_reset" @click="resetPassword">リセット</button>
                    <button class="btn_modal_reset" @click="closeResetPasswordConfirm">キャンセル</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ - パスワードリセット確認 -->
      <!-- 以下モーダルウィンドウ - パスワードリセット終了 -->
      <modal v-if="showModalReset" @close="closeModalReset">
      <!-- <modal @close="closeModalReset"> -->
        <div class="modal_main">
          <table class="tbl_modal_temppass">
            <tbody>
              <tr class="tr_modal">
                <div class="modal_comment">企業名：{{ resetCompanyName }} のパスワードをリセットしました。</div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_temp_password">
                  <div>
                    仮パスワード： <label id="target_clipcopy">{{ temporaryPassword }}</label>
                  </div>
                  <div>
                    <button class="clipcopy" data-clipboard-target="#target_clipcopy" @click="clipboardCopy">クリップボードにコピー</button>
                  </div>
                </div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_close">
                  <div></div>
                  <div>
                    <button class="btn_general" @click="closeModalReset">閉じる</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ - パスワードリセット -->
    <confirm-dialog ref="deleteDialog" modal-width='620' primary-label="削除" secondary-label="キャンセル"/>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import modal from '@/components/MunicipalityModal'
import ConfirmDialog from "@/components/ConfirmDialog";
// クリップボードコピー
import clipboard from 'clipboard'

const customId = (id) => {
  if (id.match(/^[0-9a-zA-Z+=\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]+$/)) {
    return true
  } else {
    return false
  }
}

export default {
  components: {
    modal,
    ConfirmDialog,
  },
  data: function() {
    return {
      municipalities: null,
      // 以下モーダル変数
      showModal: false,
      showPassModal: false,
      showModalResetPass: false,
      showModalReset: false,
      // リセット対象
      resetCompanyName: "",
      resetCompanyId: "",
      companyName: "",
      companyId: "",
      // エラーメッセージ
      message: "",
      messageModal: "",
      updating: false,
    }
  },
  mounted() {
    this.getCompanyList()

    console.log(this.showModalReset)
  },
  methods: {
    async getCompanyList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'company/list', {
        params: {}
      })
      this.municipalities = response.data
      // console.log(response.data)

      // console.log(this.municipalities)
    },
    async companyDel(municipality_key) {
      const municipality = this.municipalities && this.municipalities.find(municipality => municipality.municipality_key === municipality_key) || null;
      if (!municipality) {
        console.log("failed")
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${municipality.municipality_name}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'company/del', {
          municipality_key: municipality_key,
          admin_user: this.$store.getters.getStateAdminUser,
          company_name: municipality.municipality_name,
          company_id: municipality.company_id
        })
        this.getCompanyList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    municipalityCharge: function(municipality_key) {
      // 自治体コードをStoreにセット
      this.$store.commit('setStateSelectMunicipalityKey', municipality_key)
      this.$router.push({ name: 'chargeList' })
    },
    async addCompany() {
      try {
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'company/add', {
          company_name: this.companyName,
          company_id: this.companyId,
          admin_user: this.$store.getters.getStateAdminUser
        })

        this.getCompanyList()
        this.closeModal()
        // 仮パスワード
        this.temporaryPassword = response.data.TemporaryPassword
        this.openPassModal()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    openModal: function() {
      this.showModal = true
    },
		closeModal: function() {
      this.messageModal = ""
      this.companyName = ""
      this.companyId = ""
      this.showModal = false
      // validationsモデルオブジェクトをリセット
      this.$v.companyName.$reset()
      this.$v.companyId.$reset()
    },
    openPassModal: function() {
      this.showPassModal = true
    },
		closePassModal: function() {
      this.showPassModal = false
    },
    clipboardCopy: function() {
      var flag = true
      this.clipboard = new clipboard('.clipcopy')
      this.clipboard.on('success', function(e) {
        if (!flag) {
          return
        }
        alert('クリップボードにコピーしました。')
        e.clearSelection()
        flag = false
      })
    },
    async resetPassword() {
      try {
        console.log("response前")
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'company/auth-reset', {
          user_name: this.resetCompanyName,
          user_id: this.resetCompanyId
        })
        console.log("response後")
        // 仮パスワード
        this.temporaryPassword = response.data.TemporaryPassword
        this.closeModalConfirm()
        this.openModalReset()
      } catch (err) {
        console.log(err)
        this.message = err.response.data.errorMessage
      }
    },
    openResetPasswordConfirm: function(companyName, companyId) {
      this.resetCompanyName = companyName
      this.resetCompanyId = companyId
      this.openModalConfirm()
    },
    closeResetPasswordConfirm: function() {
      // 初期化
      this.resetCompanyName = ""
      this.resetCompanyId = ""
      this.closeModalConfirm()
    },
    openModalConfirm: function() {
      this.showModalResetPass = true
    },
		closeModalConfirm: function() {
			this.showModalResetPass = false
    },
    openModalReset: function() {
      this.showModalReset = true
    },
		closeModalReset: function() {
      // 初期化
      this.resetChargeName = ""
      this.resetChargeEmail = ""
      // モーダルを閉じる
      this.showModalReset = false
      // 念のため更新
      this.getCompanyList()
    },
  },
  validations: {
    companyName: {
      required,
      maxLength: maxLength(20)
    },
    companyId: {
      required,
      maxLength: maxLength(20),
      customId
    }
  }
}
</script>

<style scoped>
table th.th_charge {
  width: 60px;
}
table th.th_delete {
  width: 30px;
}
table td.td_municipality {
  text-align: left;
  padding-left: 10px;
  border-right: none;
}
table td.td_charge {
  border-left: none;
  border-right: none;
}
.btn_charge {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
  width: 58px;
}
.btn_add {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
  width: 58px;
}

/* モーダル画面 企業追加 */
table tr.tr_modal {
  border: none;
}
table th.th_modal_title {
  font-weight: normal;
  text-align: center;
  padding: 5px 0px 5px 0px;
}
.modal_search_title {
  width: 440px;
  text-align: left;
  padding: 10px 0px 0px 20px;
  font-size: 13px;
}
.tbl_modal_search {
  width: 480px;
  border-collapse: collapse;
  margin: 0 auto;
}
.modal_search {
  display: flex;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
}
.modal_input_keyword {
  width: 375px;
}
.modal_btn_close {
  display: flex;
  /* justify-content: space-between; */
  justify-content: flex-end;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 5px;
  height: 35px;
}
table td.td_modal_message {
  border: none;
  padding: 0px 0px 0px 20px;
}

/* モーダル画面 仮パスワード */
.modal_main {
  max-height: 400px;
  overflow: auto;
}
.tbl_modal_temppass {
  width: 480px;
  text-align: left;
  padding: 0px 0px 0px 20px;
  font-size: 13px;
}
.modal_comment {
  text-align: left;
  padding: 20px 0px 5px 20px;
}
.modal_temp_password {
  display: flex;
  justify-content: space-between;
  padding: 5px 5px 20px 20px;
  align-items: center;

}
.clipcopy {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
}
/* モーダル画面 - パスワードリセット確認 */
.modal_confirm {
  text-align: left;
  padding: 20px;
}
.modal_btn_reset {
  display: flex;
  justify-content: space-between;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 0px;
}
.btn_modal_reset {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
  margin-left: 5px;
}

.div_btn {
  /* float: right; */
  margin: 0.2em 2em 0 0 ;
}
</style>